<template>
  <div class="icons-container">
    <p class="warn-content">
      <a href="https://panjiachen.github.io/vue-element-admin-site/guide/advanced/icon.html" target="_blank">Add and use </a>
      从 <a href="https://www.iconfont.cn/" target="_blank">iconfont </a> 直接下载svg 图标 放入 @icons/svg 目录下, 如plane 单击图标 复制样式即可使用。
    </p>
    <div class="icons-wrapper">
      <div v-for="item of iconsMap" :key="item" v-clipboard:copy="generateIconCode(item)" v-clipboard:success="clipboardSuccess">
        <el-tooltip placement="top">
          <div slot="content">
            {{ generateIconCode(item) }}
          </div>
          <div class="icon-item">
            <svg-icon :icon-class="item" class-name="disabled" />
            <span>{{ item }}</span>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import icons from "./requireIcons"
import clipboard from "@/directive/clipboard/index.js" // use clipboard by v-directive

export default {
  name: "Icons",
  directives: {
    clipboard
  },
  data() {
    return {
      iconsMap: icons
    }
  },
  created() {
    //console.log(icons)
  },
  methods: {
    generateIconCode(symbol) {
      return `<svg-icon icon-class="${symbol}" />`
    },
    clipboardSuccess() {
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.icons-container {
  margin: 10px 20px 0;
  overflow: hidden;
  .warn-content {
    background: rgba(66, 185, 131, 0.1);
    border-radius: 2px;
    padding: 16px;
    padding: 1rem;
    line-height: 1.6rem;
    word-spacing: 0.05rem;
    color: #000;
    a {
      color: #42b983;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .icons-wrapper {
    margin: 0 auto;
  }
  .icon-item {
    margin: 20px;
    height: 110px;
    text-align: center;
    width: 110px;
    float: left;
    font-size: 28px;
    color: #24292e;
    cursor: pointer;
  }
  span {
    display: block;
    font-size: 18px;
    margin-top: 10px;
  }
  .disabled {
    pointer-events: none;
  }
}
</style>
